import _ from 'lodash'

export const wrapInCurlyBrackets = (str: string) => `{${str}}`

export const unwrapFromCurlyBrackets = (str: string) => _.trimStart(_.trimEnd(str, '}'), '{')
